<template>
  <div
    class="purchase-key paged-key"
  >
    <p>
      <span
        class="paged-key-label"
      >
        {{ keyTitle }}
      </span>

      <span
        v-for="key in showStatuses"
      >
        <purchase-status-badge
          :status="key"
        />
      </span>
    </p>
  </div>
</template>

<script>
import PurchaseStatusBadge from '@/components/PurchaseStatusBadge'

import PurchaseMixin from '@/mixins/PurchaseMixin'

export default {
  props: {
    keyTitle: {
      type: String,
      default: 'Purchase key'
    },

    statuses: {
      type: Array,
      default: () => {
        // See PurchaseMixin.
        return this.defaultStatuses
      }
    }
  },

  mixins: [
    PurchaseMixin
  ],

  computed: {
    showAllStatuses () {
      return this.statuses.includes('all')
    },

    showStatuses () {
      return this.showAllStatuses ? this.defaultStatuses : this.statuses
    }
  },

  components: {
    'purchase-status-badge': PurchaseStatusBadge
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PurchaseKey.vue